// extracted by mini-css-extract-plugin
export var typingIndicator = "_rx-0";